import { defineComponent as r, resolveComponent as n, createBlock as s, openBlock as t } from "vue";
import { v as p } from "./vsIcon-Cyr63bPF.mjs";
import { _ as c } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const i = r({
  components: { vsIcon: p },
  name: "vs-preloader",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    size: {
      type: Number,
      default: 10
    }
  },
  setup(o) {
    return {};
  }
});
function a(o, m, l, f, _, d) {
  const e = n("vs-icon");
  return t(), s(e, {
    name: "eos-icons:loading",
    color: o.color,
    size: o.size
  }, null, 8, ["color", "size"]);
}
const $ = /* @__PURE__ */ c(i, [["render", a]]);
export {
  $ as v
};
//# sourceMappingURL=vsPreloader-DE9TMol9.mjs.map
